import { gql } from "@apollo/client";

export const AssetBreadcrumbPath = gql`
    query AssetBreadcrumbPath ($id: ID!){
        assetLocation (id: $id) {
            id
            asset {
                id
                product {
                    id
                    name
                }
            }
            installedBaseNode {
                id
                key
                title
                pathNodes {
                    id
                    title
                    nodeType {
                        id
                        key
                        name
                    }
                    assetLocation {
                        id
                    }
                    system {
                        id
                    }
                }
            }
        }
    }
`;
